import chatService from '../../services/chatService';

// Action Types (see also: openChatPanel / closeChatPanel / toggleChatPanel at the bottom of this file)
export const CHAT_TYPES = {
  // Message fetching
  FETCH_CHAT_MESSAGES_REQUEST: 'FETCH_CHAT_MESSAGES_REQUEST',
  FETCH_CHAT_MESSAGES_SUCCESS: 'FETCH_CHAT_MESSAGES_SUCCESS',
  FETCH_CHAT_MESSAGES_FAILURE: 'FETCH_CHAT_MESSAGES_FAILURE',
  
  // Single message fetching
  FETCH_CHAT_MESSAGE_REQUEST: 'FETCH_CHAT_MESSAGE_REQUEST',
  FETCH_CHAT_MESSAGE_SUCCESS: 'FETCH_CHAT_MESSAGE_SUCCESS',
  FETCH_CHAT_MESSAGE_FAILURE: 'FETCH_CHAT_MESSAGE_FAILURE',
  
  // Realtime socket messages (Phase 11a)
  RECEIVE_SOCKET_MESSAGE: 'RECEIVE_SOCKET_MESSAGE',
  RECEIVE_SOCKET_TYPING: 'RECEIVE_SOCKET_TYPING',
  RECEIVE_SOCKET_PRESENCE: 'RECEIVE_SOCKET_PRESENCE',

  // Message sending
  SEND_CHAT_MESSAGE_REQUEST: 'SEND_CHAT_MESSAGE_REQUEST',
  SEND_CHAT_MESSAGE_SUCCESS: 'SEND_CHAT_MESSAGE_SUCCESS',
  SEND_CHAT_MESSAGE_FAILURE: 'SEND_CHAT_MESSAGE_FAILURE',
  
  // Message deletion
  DELETE_CHAT_MESSAGE_REQUEST: 'DELETE_CHAT_MESSAGE_REQUEST',
  DELETE_CHAT_MESSAGE_SUCCESS: 'DELETE_CHAT_MESSAGE_SUCCESS',
  DELETE_CHAT_MESSAGE_FAILURE: 'DELETE_CHAT_MESSAGE_FAILURE',
  
  // Message editing
  EDIT_CHAT_MESSAGE_REQUEST: 'EDIT_CHAT_MESSAGE_REQUEST',
  EDIT_CHAT_MESSAGE_SUCCESS: 'EDIT_CHAT_MESSAGE_SUCCESS',
  EDIT_CHAT_MESSAGE_FAILURE: 'EDIT_CHAT_MESSAGE_FAILURE',
  
  // Reply
  SET_REPLY_TO_MESSAGE: 'SET_REPLY_TO_MESSAGE',
  CLEAR_REPLY_TO_MESSAGE: 'CLEAR_REPLY_TO_MESSAGE',
  
  // Conversation creation
  CREATE_CONVERSATION_REQUEST: 'CREATE_CONVERSATION_REQUEST',
  CREATE_CONVERSATION_SUCCESS: 'CREATE_CONVERSATION_SUCCESS',
  CREATE_CONVERSATION_FAILURE: 'CREATE_CONVERSATION_FAILURE',
  
  // Conversation fetching
  FETCH_CONVERSATIONS_REQUEST: 'FETCH_CONVERSATIONS_REQUEST',
  FETCH_CONVERSATIONS_SUCCESS: 'FETCH_CONVERSATIONS_SUCCESS',
  FETCH_CONVERSATIONS_FAILURE: 'FETCH_CONVERSATIONS_FAILURE',
  
  // Single conversation fetching
  FETCH_CONVERSATION_REQUEST: 'FETCH_CONVERSATION_REQUEST',
  FETCH_CONVERSATION_SUCCESS: 'FETCH_CONVERSATION_SUCCESS',
  FETCH_CONVERSATION_FAILURE: 'FETCH_CONVERSATION_FAILURE',
  
  // Conversation messages fetching
  FETCH_CONVERSATION_MESSAGES_REQUEST: 'FETCH_CONVERSATION_MESSAGES_REQUEST',
  FETCH_CONVERSATION_MESSAGES_SUCCESS: 'FETCH_CONVERSATION_MESSAGES_SUCCESS',
  FETCH_CONVERSATION_MESSAGES_FAILURE: 'FETCH_CONVERSATION_MESSAGES_FAILURE',
  
  // Conversation status updates
  UPDATE_CONVERSATION_STATUS_REQUEST: 'UPDATE_CONVERSATION_STATUS_REQUEST',
  UPDATE_CONVERSATION_STATUS_SUCCESS: 'UPDATE_CONVERSATION_STATUS_SUCCESS',
  UPDATE_CONVERSATION_STATUS_FAILURE: 'UPDATE_CONVERSATION_STATUS_FAILURE',
  
  // Conversation UI state
  SET_ACTIVE_CONVERSATION: 'SET_ACTIVE_CONVERSATION',
  CLEAR_ACTIVE_CONVERSATION: 'CLEAR_ACTIVE_CONVERSATION',

  // Mark-as-read & unread counts (watermark system)
  MARK_AS_READ_REQUEST: 'MARK_AS_READ_REQUEST',
  MARK_AS_READ_SUCCESS: 'MARK_AS_READ_SUCCESS',
  MARK_AS_READ_FAILURE: 'MARK_AS_READ_FAILURE',
  FETCH_UNREAD_COUNTS_REQUEST: 'FETCH_UNREAD_COUNTS_REQUEST',
  FETCH_UNREAD_COUNTS_SUCCESS: 'FETCH_UNREAD_COUNTS_SUCCESS',
  FETCH_UNREAD_COUNTS_FAILURE: 'FETCH_UNREAD_COUNTS_FAILURE',

  // Conversation message sending (separate from room messages)
  SEND_CONVERSATION_MESSAGE_REQUEST: 'SEND_CONVERSATION_MESSAGE_REQUEST',
  SEND_CONVERSATION_MESSAGE_SUCCESS: 'SEND_CONVERSATION_MESSAGE_SUCCESS',
  SEND_CONVERSATION_MESSAGE_FAILURE: 'SEND_CONVERSATION_MESSAGE_FAILURE',

  // Queue system (knock/join for sensitive conversations)
  KNOCK_CONVERSATION_REQUEST: 'KNOCK_CONVERSATION_REQUEST',
  KNOCK_CONVERSATION_SUCCESS: 'KNOCK_CONVERSATION_SUCCESS',
  KNOCK_CONVERSATION_FAILURE: 'KNOCK_CONVERSATION_FAILURE',
  APPROVE_KNOCK_REQUEST: 'APPROVE_KNOCK_REQUEST',
  APPROVE_KNOCK_SUCCESS: 'APPROVE_KNOCK_SUCCESS',
  APPROVE_KNOCK_FAILURE: 'APPROVE_KNOCK_FAILURE',
  DENY_KNOCK_REQUEST: 'DENY_KNOCK_REQUEST',
  DENY_KNOCK_SUCCESS: 'DENY_KNOCK_SUCCESS',
  DENY_KNOCK_FAILURE: 'DENY_KNOCK_FAILURE',
  FETCH_QUEUE_REQUEST: 'FETCH_QUEUE_REQUEST',
  FETCH_QUEUE_SUCCESS: 'FETCH_QUEUE_SUCCESS',
  FETCH_QUEUE_FAILURE: 'FETCH_QUEUE_FAILURE',
  CANCEL_KNOCK_REQUEST: 'CANCEL_KNOCK_REQUEST',
  CANCEL_KNOCK_SUCCESS: 'CANCEL_KNOCK_SUCCESS',
  CANCEL_KNOCK_FAILURE: 'CANCEL_KNOCK_FAILURE',

  // Add participant
  ADD_PARTICIPANT_REQUEST: 'ADD_PARTICIPANT_REQUEST',
  ADD_PARTICIPANT_SUCCESS: 'ADD_PARTICIPANT_SUCCESS',
  ADD_PARTICIPANT_FAILURE: 'ADD_PARTICIPANT_FAILURE',

  // Tab-specific message fetching (per-tab storage in Redux — fixes dual-store bug)
  FETCH_TAB_MESSAGES_REQUEST: 'FETCH_TAB_MESSAGES_REQUEST',
  FETCH_TAB_MESSAGES_SUCCESS: 'FETCH_TAB_MESSAGES_SUCCESS',
  FETCH_TAB_MESSAGES_FAILURE: 'FETCH_TAB_MESSAGES_FAILURE',

  // Reply-post system
  SET_REPLY_POST_DATA: 'SET_REPLY_POST_DATA',
  UPDATE_STANCE_TALLIES: 'UPDATE_STANCE_TALLIES',
  BUMP_REPLY_POST: 'BUMP_REPLY_POST',

  // User post states (muted/suppressed/hidden)
  FETCH_USER_POST_STATES_REQUEST: 'FETCH_USER_POST_STATES_REQUEST',
  FETCH_USER_POST_STATES_SUCCESS: 'FETCH_USER_POST_STATES_SUCCESS',
  FETCH_USER_POST_STATES_FAILURE: 'FETCH_USER_POST_STATES_FAILURE',
  SET_USER_POST_STATE_REQUEST: 'SET_USER_POST_STATE_REQUEST',
  SET_USER_POST_STATE_SUCCESS: 'SET_USER_POST_STATE_SUCCESS',
  SET_USER_POST_STATE_FAILURE: 'SET_USER_POST_STATE_FAILURE',

  // Leave conversation
  LEAVE_CONVERSATION_REQUEST: 'LEAVE_CONVERSATION_REQUEST',
  LEAVE_CONVERSATION_SUCCESS: 'LEAVE_CONVERSATION_SUCCESS',
  LEAVE_CONVERSATION_FAILURE: 'LEAVE_CONVERSATION_FAILURE',

  // Toggle conversation mute
  TOGGLE_CONVERSATION_MUTE_REQUEST: 'TOGGLE_CONVERSATION_MUTE_REQUEST',
  TOGGLE_CONVERSATION_MUTE_SUCCESS: 'TOGGLE_CONVERSATION_MUTE_SUCCESS',
  TOGGLE_CONVERSATION_MUTE_FAILURE: 'TOGGLE_CONVERSATION_MUTE_FAILURE',

  // Fetch message replies (reply-post expansion)
  FETCH_MESSAGE_REPLIES_REQUEST: 'FETCH_MESSAGE_REPLIES_REQUEST',
  FETCH_MESSAGE_REPLIES_SUCCESS: 'FETCH_MESSAGE_REPLIES_SUCCESS',
  FETCH_MESSAGE_REPLIES_FAILURE: 'FETCH_MESSAGE_REPLIES_FAILURE',

  // Role management (REQ-17)
  PROMOTE_PARTICIPANT_REQUEST: 'PROMOTE_PARTICIPANT_REQUEST',
  PROMOTE_PARTICIPANT_SUCCESS: 'PROMOTE_PARTICIPANT_SUCCESS',
  PROMOTE_PARTICIPANT_FAILURE: 'PROMOTE_PARTICIPANT_FAILURE',
  TRANSFER_ADMIN_REQUEST: 'TRANSFER_ADMIN_REQUEST',
  TRANSFER_ADMIN_SUCCESS: 'TRANSFER_ADMIN_SUCCESS',
  TRANSFER_ADMIN_FAILURE: 'TRANSFER_ADMIN_FAILURE',
  KICK_PARTICIPANT_REQUEST: 'KICK_PARTICIPANT_REQUEST',
  KICK_PARTICIPANT_SUCCESS: 'KICK_PARTICIPANT_SUCCESS',
  KICK_PARTICIPANT_FAILURE: 'KICK_PARTICIPANT_FAILURE',

  // Admin challenge system (REQ-18)
  CREATE_CHALLENGE_REQUEST: 'CREATE_CHALLENGE_REQUEST',
  CREATE_CHALLENGE_SUCCESS: 'CREATE_CHALLENGE_SUCCESS',
  CREATE_CHALLENGE_FAILURE: 'CREATE_CHALLENGE_FAILURE',
  DISMISS_CHALLENGE_REQUEST: 'DISMISS_CHALLENGE_REQUEST',
  DISMISS_CHALLENGE_SUCCESS: 'DISMISS_CHALLENGE_SUCCESS',
  DISMISS_CHALLENGE_FAILURE: 'DISMISS_CHALLENGE_FAILURE',

  // Privacy management (REQ-22, REQ-23)
  UPDATE_PRIVACY_REQUEST: 'UPDATE_PRIVACY_REQUEST',
  UPDATE_PRIVACY_SUCCESS: 'UPDATE_PRIVACY_SUCCESS',
  UPDATE_PRIVACY_FAILURE: 'UPDATE_PRIVACY_FAILURE',

  // Edit history (REQ-25)
  FETCH_EDIT_HISTORY_REQUEST: 'FETCH_EDIT_HISTORY_REQUEST',
  FETCH_EDIT_HISTORY_SUCCESS: 'FETCH_EDIT_HISTORY_SUCCESS',
  FETCH_EDIT_HISTORY_FAILURE: 'FETCH_EDIT_HISTORY_FAILURE',

  // Floating chat panel (desktop)
  OPEN_CHAT_PANEL: 'OPEN_CHAT_PANEL',
  CLOSE_CHAT_PANEL: 'CLOSE_CHAT_PANEL',
  TOGGLE_CHAT_PANEL: 'TOGGLE_CHAT_PANEL'
};

// Action Creators

/**
 * Fetch chat messages
 * @param {Object} options - Options for fetching messages
 * @returns {Function} - Thunk function
 */
export const fetchChatMessages = (options = {}) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_CHAT_MESSAGES_REQUEST });
    
    const response = await chatService.fetchMessages(options);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.FETCH_CHAT_MESSAGES_SUCCESS,
        payload: response.messages
      });
      return { success: true, messages: response.messages };
    } else {
      dispatch({
        type: CHAT_TYPES.FETCH_CHAT_MESSAGES_FAILURE,
        payload: response.message || 'Failed to fetch chat messages'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.FETCH_CHAT_MESSAGES_FAILURE,
      payload: error.message || 'Failed to fetch chat messages'
    });
    return { success: false, message: error.message };
  }
};

/**
 * Fetch chat messages for a specific tab and store under that tab key in Redux.
 * This replaces the old pattern of fetching into a flat messages array + local useState.
 * @param {string} tabKey - Tab identifier ('public', 'community', 'state')
 * @param {Object} options - Options for fetching messages
 * @returns {Function} - Thunk function
 */
export const fetchTabMessages = (tabKey, options = {}) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_TAB_MESSAGES_REQUEST, payload: { tabKey } });
    
    const response = await chatService.fetchMessages(options);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.FETCH_TAB_MESSAGES_SUCCESS,
        payload: { tabKey, messages: response.messages || [] }
      });

      // Store reply-post enrichment data (tallies + last replies) returned by the API
      if (response.replyPostEnrichment) {
        Object.entries(response.replyPostEnrichment).forEach(([msgId, data]) => {
          // Store tallies + metadata in replyPosts map
          dispatch({
            type: CHAT_TYPES.SET_REPLY_POST_DATA,
            payload: {
              messageId: msgId,
              tallies: data.tallies || { agree: 0, disagree: 0 },
              replyCount: data.totalReplyCount || 0,
              lastReplyAt: null,
              participantNames: data.participantNames || {},
              participantAvatars: data.participantAvatars || {}
            }
          });
          // Store actual reply content in messageReplies map
          if (data.lastReplies && data.lastReplies.length > 0) {
            dispatch({
              type: CHAT_TYPES.FETCH_MESSAGE_REPLIES_SUCCESS,
              payload: {
                messageId: msgId,
                replies: data.lastReplies,
                tallies: data.tallies || { agree: 0, disagree: 0 },
                totalCount: data.totalReplyCount || 0
              }
            });
          }
        });
      }

      return { success: true, messages: response.messages };
    } else {
      dispatch({
        type: CHAT_TYPES.FETCH_TAB_MESSAGES_FAILURE,
        payload: { tabKey, error: response.message || 'Failed to fetch messages' }
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.FETCH_TAB_MESSAGES_FAILURE,
      payload: { tabKey, error: error.message }
    });
    return { success: false, message: error.message };
  }
};

/**
 * Send a new chat message
 * @param {string} messageContent - Message content text
 * @param {string} messageType - Message type (chat, reply, convo-chat, convo-reply)
 * @param {string} replyToId - ID of message being replied to (or 'false')
 * @param {string} chatType - Chat type (global, convo, state, state-convo)
 * @param {string} state - State context (or 'false' for global)
 * @param {string} conversationId - ID of the conversation this message belongs to (optional)
 * @returns {Function} - Thunk function
 */
export const sendChatMessage = (
  messageContent, 
  messageType = 'chat', 
  replyToId = 'false', 
  chatType = 'global', 
  state = 'false',
  conversationId = null,
  stance = 'neutral'
) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.SEND_CHAT_MESSAGE_REQUEST });
    
    // Route to correct endpoint based on whether this is a room or conversation message
    let response;
    if (conversationId) {
      // Conversation messages go to /api/chat/conversations/:id/messages
      response = await chatService.sendConversationMessage(conversationId, {
        userChatMessageContents: messageContent,
        messageType,
        messageReplyToId: replyToId,
        stance
      });
    } else {
      // Room messages go to /api/chat/send
      response = await chatService.sendMessage({
        userChatMessageContents: messageContent,
        messageType,
        messageReplyToId: replyToId,
        messageChatType: chatType,
        messageState: state,
        stance
      });
    }
    
    if (response.success) {
      if (conversationId) {
        // Conversation messages use their own SUCCESS type so reducer appends to conversationMessages
        dispatch({
          type: CHAT_TYPES.SEND_CONVERSATION_MESSAGE_SUCCESS,
          payload: { conversationId, message: response.message }
        });
      } else {
        // Derive which tab this message belongs to for per-tab message sync
        const tabKey = 
          chatType === 'global' ? 'public' : 
          chatType === 'community' ? 'community' : 
          chatType === 'state' ? 'state' : null;
        dispatch({
          type: CHAT_TYPES.SEND_CHAT_MESSAGE_SUCCESS,
          payload: { message: response.message, tabKey }
        });
      }
      return { success: true, message: response.message };
    } else {
      dispatch({
        type: CHAT_TYPES.SEND_CHAT_MESSAGE_FAILURE,
        payload: response.message || 'Failed to send message'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.SEND_CHAT_MESSAGE_FAILURE,
      payload: error.message || 'Failed to send message'
    });
    return { success: false, message: error.message };
  }
};

/**
 * Delete a chat message
 * @param {string} messageId - ID of message to delete
 * @returns {Function} - Thunk function
 */
export const deleteChatMessage = (messageId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.DELETE_CHAT_MESSAGE_REQUEST });
    
    const response = await chatService.deleteMessage(messageId);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.DELETE_CHAT_MESSAGE_SUCCESS,
        payload: messageId
      });
      return { success: true };
    } else {
      dispatch({
        type: CHAT_TYPES.DELETE_CHAT_MESSAGE_FAILURE,
        payload: response.message || 'Failed to delete message'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.DELETE_CHAT_MESSAGE_FAILURE,
      payload: error.message || 'Failed to delete message'
    });
    return { success: false, message: error.message };
  }
};

/**
 * Edit a chat message
 * @param {string} messageId - ID of message to edit
 * @param {string} newContent - Updated message content
 * @returns {Function} - Thunk function
 */
export const editChatMessage = (messageId, newContent) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.EDIT_CHAT_MESSAGE_REQUEST });
    
    const response = await chatService.editMessage(messageId, newContent);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.EDIT_CHAT_MESSAGE_SUCCESS,
        payload: response.message
      });
      return { success: true, message: response.message };
    } else {
      dispatch({
        type: CHAT_TYPES.EDIT_CHAT_MESSAGE_FAILURE,
        payload: response.message || 'Failed to edit message'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.EDIT_CHAT_MESSAGE_FAILURE,
      payload: error.message || 'Failed to edit message'
    });
    return { success: false, message: error.message };
  }
};

/**
 * Fetch a specific chat message by ID (used for retrieving original messages in replies)
 * @param {string} messageId - ID of message to fetch
 * @returns {Function} - Thunk function
 */
export const fetchChatMessageById = (messageId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_CHAT_MESSAGE_REQUEST });
    
    const response = await chatService.getMessageById(messageId);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.FETCH_CHAT_MESSAGE_SUCCESS,
        payload: response.message
      });
      return { success: true, message: response.message };
    } else {
      dispatch({
        type: CHAT_TYPES.FETCH_CHAT_MESSAGE_FAILURE,
        payload: response.message || 'Failed to fetch message'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.FETCH_CHAT_MESSAGE_FAILURE,
      payload: error.message || 'Failed to fetch message'
    });
    return { success: false, message: error.message };
  }
};

/**
 * Set a message as the one being replied to
 * @param {Object} message - Message being replied to
 * @returns {Object} - Action object
 */
export const setReplyToMessage = (message) => ({
  type: CHAT_TYPES.SET_REPLY_TO_MESSAGE,
  payload: message
});

/**
 * Clear the current reply-to message
 * @returns {Object} - Action object
 */
export const clearReplyToMessage = () => ({
  type: CHAT_TYPES.CLEAR_REPLY_TO_MESSAGE
});

/**
 * Create a new conversation
 * @param {Object} conversationData - Conversation data (title, description, originalMessageIds)
 * @returns {Function} - Thunk function
 */
export const createConversation = (conversationData) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.CREATE_CONVERSATION_REQUEST });
    
    const response = await chatService.createConversation(conversationData);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.CREATE_CONVERSATION_SUCCESS,
        payload: response.conversation
      });
      return { success: true, conversation: response.conversation };
    } else {
      dispatch({
        type: CHAT_TYPES.CREATE_CONVERSATION_FAILURE,
        payload: response.message || 'Failed to create conversation'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.CREATE_CONVERSATION_FAILURE,
      payload: error.message || 'Failed to create conversation'
    });
    return { success: false, message: error.message };
  }
};

/**
 * Fetch all conversations
 * @param {Object} options - Options for fetching conversations (filter, sort, limit)
 * @returns {Function} - Thunk function
 */
export const fetchConversations = (options = {}) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_CONVERSATIONS_REQUEST });
    
    // Ensure we're getting all statuses if not explicitly specified
    const fetchOptions = {
      ...options,
      status: options.status || 'all' // Default to 'all' if not specified
    };
    
    const response = await chatService.fetchConversations(fetchOptions);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.FETCH_CONVERSATIONS_SUCCESS,
        payload: response.conversations
      });
      return { success: true, conversations: response.conversations };
    } else {
      dispatch({
        type: CHAT_TYPES.FETCH_CONVERSATIONS_FAILURE,
        payload: response.message || 'Failed to fetch conversations'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.FETCH_CONVERSATIONS_FAILURE,
      payload: error.message || 'Failed to fetch conversations'
    });
    return { success: false, message: error.message };
  }
};

/**
 * Fetch a specific conversation by ID
 * @param {string} conversationId - ID of conversation to fetch
 * @returns {Function} - Thunk function
 */
export const fetchConversationById = (conversationId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_CONVERSATION_REQUEST });
    
    const response = await chatService.getConversationById(conversationId);
    
    if (response.success) {
      // The enhanced getConversationById now also fetches messages
      const payload = {
        ...response.conversation,
        messages: response.messages || [] // Include messages if available
      };
      
      dispatch({
        type: CHAT_TYPES.FETCH_CONVERSATION_SUCCESS,
        payload
      });
      
      // If we have messages, also dispatch them to update the messages state
      if (response.messages && response.messages.length > 0) {
        dispatch({
          type: CHAT_TYPES.FETCH_CONVERSATION_MESSAGES_SUCCESS,
          payload: {
            conversationId,
            messages: response.messages
          }
        });
      }
      
      return { 
        success: true, 
        conversation: payload,
        hasMessages: !!response.messages && response.messages.length > 0 
      };
    } else {
      dispatch({
        type: CHAT_TYPES.FETCH_CONVERSATION_FAILURE,
        payload: response.message || 'Failed to fetch conversation'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.FETCH_CONVERSATION_FAILURE,
      payload: error.message || 'Failed to fetch conversation'
    });
    return { success: false, message: error.message };
  }
}

/**
 * Fetch messages for a specific conversation
 * @param {string} conversationId - The ID of the conversation to fetch messages for
 * @param {Object} options - Optional parameters like page, limit
 * @returns {Function} - Redux thunk function
 */
export const fetchConversationMessages = (conversationId, options = {}) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_CONVERSATION_MESSAGES_REQUEST });
    
    const response = await chatService.getConversationMessages(conversationId, options);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.FETCH_CONVERSATION_MESSAGES_SUCCESS,
        payload: {
          conversationId,
          messages: response.messages
        }
      });
      return { success: true, messages: response.messages };
    } else {
      dispatch({
        type: CHAT_TYPES.FETCH_CONVERSATION_MESSAGES_FAILURE,
        payload: response.message || 'Failed to fetch conversation messages'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.FETCH_CONVERSATION_MESSAGES_FAILURE,
      payload: error.message || 'Failed to fetch conversation messages'
    });
    return { success: false, message: error.message };
  }
}

/**
 * Update a conversation's status
 * @param {string} conversationId - ID of conversation to update
 * @param {string} newStatus - New status to set (Active, Still, Idle, Archived)
 * @returns {Function} - Thunk function
 */
export const updateConversationStatus = (conversationId, newStatus) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.UPDATE_CONVERSATION_STATUS_REQUEST });
    
    const response = await chatService.updateConversationStatus(conversationId, newStatus);
    
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.UPDATE_CONVERSATION_STATUS_SUCCESS,
        payload: { id: conversationId, status: newStatus }
      });
      return { success: true };
    } else {
      dispatch({
        type: CHAT_TYPES.UPDATE_CONVERSATION_STATUS_FAILURE,
        payload: response.message || 'Failed to update conversation status'
      });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({
      type: CHAT_TYPES.UPDATE_CONVERSATION_STATUS_FAILURE,
      payload: error.message || 'Failed to update conversation status'
    });
    return { success: false, message: error.message };
  }
};

/**
 * Set the active conversation in the UI
 * @param {Object} conversation - Conversation object to set as active
 * @returns {Object} - Action object
 */
export const setActiveConversation = (conversation) => ({
  type: CHAT_TYPES.SET_ACTIVE_CONVERSATION,
  payload: conversation
});

/**
 * Clear the active conversation in the UI
 * @returns {Object} - Action object
 */
export const clearActiveConversation = () => ({
  type: CHAT_TYPES.CLEAR_ACTIVE_CONVERSATION
});

// ============================================================
// MARK-AS-READ & UNREAD COUNTS
// ============================================================

/**
 * Mark a room or conversation as read (updates user's lastReadAt watermark)
 * @param {Object} params - { roomId } or { conversationId }
 * @returns {Function} - Thunk function
 */
export const markAsRead = (params) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.MARK_AS_READ_REQUEST });
    const response = await chatService.markAsRead(params);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.MARK_AS_READ_SUCCESS, payload: params });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.MARK_AS_READ_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.MARK_AS_READ_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Fetch unread counts for all rooms/conversations
 * @returns {Function} - Thunk function
 */
export const fetchUnreadCounts = () => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_UNREAD_COUNTS_REQUEST });
    const response = await chatService.getUnreadCounts();
    if (response.success) {
      dispatch({ type: CHAT_TYPES.FETCH_UNREAD_COUNTS_SUCCESS, payload: response.counts });
      return { success: true, counts: response.counts };
    } else {
      dispatch({ type: CHAT_TYPES.FETCH_UNREAD_COUNTS_FAILURE, payload: response.message });
      return { success: false };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.FETCH_UNREAD_COUNTS_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

// ============================================================
// ADD PARTICIPANT
// ============================================================

/**
 * Add a participant to a conversation
 * @param {string} conversationId
 * @param {string} userId
 * @returns {Function} - Thunk function
 */
export const addConversationParticipant = (conversationId, userId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.ADD_PARTICIPANT_REQUEST });
    const response = await chatService.addParticipant(conversationId, userId);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.ADD_PARTICIPANT_SUCCESS, payload: { conversationId, userId } });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.ADD_PARTICIPANT_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.ADD_PARTICIPANT_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

// ============================================================
// QUEUE SYSTEM (knock/join for sensitive conversations)
// ============================================================

/**
 * Submit a knock request to join a sensitive conversation
 * @param {string} conversationId
 * @param {string} message - Optional message with the knock
 * @returns {Function}
 */
export const knockConversation = (conversationId, message = '') => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.KNOCK_CONVERSATION_REQUEST });
    const response = await chatService.knockConversation(conversationId, message);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.KNOCK_CONVERSATION_SUCCESS, payload: response.request });
      return { success: true, request: response.request };
    } else {
      dispatch({ type: CHAT_TYPES.KNOCK_CONVERSATION_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.KNOCK_CONVERSATION_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Approve a pending knock request
 * @param {string} requestId
 * @returns {Function}
 */
export const approveKnock = (requestId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.APPROVE_KNOCK_REQUEST });
    const response = await chatService.approveKnock(requestId);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.APPROVE_KNOCK_SUCCESS, payload: response.request });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.APPROVE_KNOCK_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.APPROVE_KNOCK_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Deny a pending knock request
 * @param {string} requestId
 * @param {string} note - Optional denial reason
 * @returns {Function}
 */
export const denyKnock = (requestId, note = '') => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.DENY_KNOCK_REQUEST });
    const response = await chatService.denyKnock(requestId, note);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.DENY_KNOCK_SUCCESS, payload: response.request });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.DENY_KNOCK_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.DENY_KNOCK_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Fetch the pending knock queue for a conversation
 * @param {string} conversationId
 * @returns {Function}
 */
export const fetchQueue = (conversationId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_QUEUE_REQUEST });
    const response = await chatService.getQueue(conversationId);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.FETCH_QUEUE_SUCCESS, payload: { conversationId, queue: response.queue } });
      return { success: true, queue: response.queue };
    } else {
      dispatch({ type: CHAT_TYPES.FETCH_QUEUE_FAILURE, payload: response.message });
      return { success: false };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.FETCH_QUEUE_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Cancel your own pending knock request
 * @param {string} requestId
 * @returns {Function}
 */
export const cancelKnock = (requestId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.CANCEL_KNOCK_REQUEST });
    const response = await chatService.cancelKnock(requestId);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.CANCEL_KNOCK_SUCCESS, payload: { requestId } });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.CANCEL_KNOCK_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.CANCEL_KNOCK_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

// ============================================================
// REPLY-POST & STANCE SYSTEM
// ============================================================

/**
 * Fetch user post states (muted/suppressed/hidden) for all reply-posts
 * @returns {Function} - Thunk function
 */
export const fetchUserPostStates = () => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_USER_POST_STATES_REQUEST });
    const response = await chatService.getUserPostStates();
    if (response.success) {
      dispatch({ type: CHAT_TYPES.FETCH_USER_POST_STATES_SUCCESS, payload: response.states });
      return { success: true, states: response.states };
    } else {
      dispatch({ type: CHAT_TYPES.FETCH_USER_POST_STATES_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.FETCH_USER_POST_STATES_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Set user post state for a specific conversation (REQ-06: conversationId replaces messageId)
 * @param {string} conversationId - ID of the conversation
 * @param {string} postState - Post state ('default'|'suppressed'|'hidden')
 * @param {boolean} isMuted - Whether to mute notifications/sounds
 * @returns {Function} - Thunk function
 */
export const setUserPostState = (conversationId, postState, isMuted) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.SET_USER_POST_STATE_REQUEST });
    const response = await chatService.setUserPostState(conversationId, postState, isMuted);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.SET_USER_POST_STATE_SUCCESS, payload: { conversationId, state: postState, isMuted } });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.SET_USER_POST_STATE_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.SET_USER_POST_STATE_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Leave a conversation (REQ-19: snooze or abandon)
 * @param {string} conversationId - ID of conversation to leave
 * @param {string} leaveType - 'snooze' (can rejoin) or 'abandon' (permanent)
 * @returns {Function} - Thunk function
 */
export const leaveConversation = (conversationId, leaveType = 'snooze') => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.LEAVE_CONVERSATION_REQUEST });
    const response = await chatService.leaveConversation(conversationId, leaveType);
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.LEAVE_CONVERSATION_SUCCESS,
        payload: { conversationId, participantCount: response.participantCount, newAdmin: response.newAdmin || null, leaveType }
      });
      return { success: true, newAdmin: response.newAdmin };
    } else {
      dispatch({ type: CHAT_TYPES.LEAVE_CONVERSATION_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.LEAVE_CONVERSATION_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Toggle mute state for a conversation
 * @param {string} conversationId - ID of conversation
 * @param {boolean} muted - Whether to mute (true) or unmute (false)
 * @returns {Function} - Thunk function
 */
export const toggleConversationMute = (conversationId, muted) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.TOGGLE_CONVERSATION_MUTE_REQUEST });
    const response = await chatService.toggleConversationMute(conversationId, muted);
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.TOGGLE_CONVERSATION_MUTE_SUCCESS,
        payload: { conversationId, isMuted: response.isMuted }
      });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.TOGGLE_CONVERSATION_MUTE_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.TOGGLE_CONVERSATION_MUTE_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Fetch paginated replies for a specific message (reply-post expansion)
 * @param {string} messageId - ID of the parent message
 * @param {Object} options - { limit, offset, all }
 * @returns {Function} - Thunk function
 */
export const fetchMessageReplies = (messageId, options = {}) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_MESSAGE_REPLIES_REQUEST });
    const response = await chatService.getMessageReplies(messageId, options);
    if (response.success) {
      dispatch({
        type: CHAT_TYPES.FETCH_MESSAGE_REPLIES_SUCCESS,
        payload: {
          messageId,
          replies: response.replies,
          tallies: response.tallies,
          totalCount: response.totalCount
        }
      });
      // Sync tallies to replyPosts state (keeps ReplyPostCard tally display in sync)
      if (response.tallies) {
        dispatch({ type: CHAT_TYPES.UPDATE_STANCE_TALLIES, payload: { messageId, tallies: response.tallies } });
      }
      return { success: true, replies: response.replies, tallies: response.tallies };
    } else {
      dispatch({ type: CHAT_TYPES.FETCH_MESSAGE_REPLIES_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.FETCH_MESSAGE_REPLIES_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

// ---- Floating Chat Panel (desktop) ----
export const openChatPanel = () => ({ type: CHAT_TYPES.OPEN_CHAT_PANEL });
export const closeChatPanel = () => ({ type: CHAT_TYPES.CLOSE_CHAT_PANEL });
export const toggleChatPanel = () => ({ type: CHAT_TYPES.TOGGLE_CHAT_PANEL });

// ============================================================
// ROLE MANAGEMENT (REQ-17)
// ============================================================

/**
 * Promote a participant to moderator
 * @param {string} conversationId - Conversation ID
 * @param {string} userId - User ID to promote
 * @returns {Function}
 */
export const promoteParticipant = (conversationId, userId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.PROMOTE_PARTICIPANT_REQUEST });
    const response = await chatService.promoteParticipant(conversationId, userId);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.PROMOTE_PARTICIPANT_SUCCESS, payload: { conversationId, userId, participant: response.participant } });
      return { success: true, participant: response.participant };
    } else {
      dispatch({ type: CHAT_TYPES.PROMOTE_PARTICIPANT_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.PROMOTE_PARTICIPANT_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Transfer admin role to another participant
 * @param {string} conversationId - Conversation ID
 * @param {string} targetUserId - User ID to receive admin
 * @returns {Function}
 */
export const transferAdmin = (conversationId, targetUserId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.TRANSFER_ADMIN_REQUEST });
    const response = await chatService.transferAdmin(conversationId, targetUserId);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.TRANSFER_ADMIN_SUCCESS, payload: { conversationId, newAdmin: response.newAdmin, previousAdmin: response.previousAdmin } });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.TRANSFER_ADMIN_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.TRANSFER_ADMIN_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Kick a participant from a conversation (REQ-17, REQ-31, REQ-32)
 * @param {string} conversationId - Conversation ID
 * @param {string} targetUserId - User ID to kick
 * @param {string} reason - Optional reason
 * @returns {Function}
 */
export const kickParticipant = (conversationId, targetUserId, reason = '') => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.KICK_PARTICIPANT_REQUEST });
    const response = await chatService.kickParticipant(conversationId, targetUserId, reason);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.KICK_PARTICIPANT_SUCCESS, payload: { conversationId, targetUserId, systemMessage: response.systemMessage } });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.KICK_PARTICIPANT_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.KICK_PARTICIPANT_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

// ============================================================
// ADMIN CHALLENGE SYSTEM (REQ-18)
// ============================================================

/**
 * Create an admin challenge
 * @param {string} conversationId - Conversation ID
 * @param {string} reason - Challenge reason
 * @returns {Function}
 */
export const createChallenge = (conversationId, reason) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.CREATE_CHALLENGE_REQUEST });
    const response = await chatService.createChallenge(conversationId, reason);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.CREATE_CHALLENGE_SUCCESS, payload: { conversationId, challenge: response.challenge || { challengeId: response.challengeId, expiresAt: response.expiresAt } } });
      return { success: true, challengeId: response.challengeId, expiresAt: response.expiresAt };
    } else {
      dispatch({ type: CHAT_TYPES.CREATE_CHALLENGE_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.CREATE_CHALLENGE_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

/**
 * Dismiss an admin challenge (admin-only)
 * @param {string} conversationId - Conversation ID
 * @param {string} challengeId - Challenge ID
 * @returns {Function}
 */
export const dismissChallenge = (conversationId, challengeId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.DISMISS_CHALLENGE_REQUEST });
    const response = await chatService.dismissChallenge(conversationId, challengeId);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.DISMISS_CHALLENGE_SUCCESS, payload: { conversationId, challengeId } });
      return { success: true };
    } else {
      dispatch({ type: CHAT_TYPES.DISMISS_CHALLENGE_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.DISMISS_CHALLENGE_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

// ============================================================
// PRIVACY MANAGEMENT (REQ-22, REQ-23)
// ============================================================

/**
 * Update conversation privacy level
 * @param {string} conversationId - Conversation ID
 * @param {string} privacyLevel - New privacy level
 * @returns {Function}
 */
export const updatePrivacy = (conversationId, privacyLevel) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.UPDATE_PRIVACY_REQUEST });
    const response = await chatService.updatePrivacy(conversationId, privacyLevel);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.UPDATE_PRIVACY_SUCCESS, payload: { conversationId, conversation: response.conversation } });
      return { success: true, conversation: response.conversation };
    } else {
      dispatch({ type: CHAT_TYPES.UPDATE_PRIVACY_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.UPDATE_PRIVACY_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};

// ============================================================
// EDIT HISTORY (REQ-25)
// ============================================================

/**
 * Fetch edit history for a message
 * @param {string} conversationId - Conversation ID (for route path)
 * @param {string} messageId - Message ID
 * @returns {Function}
 */
export const fetchEditHistory = (conversationId, messageId) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_TYPES.FETCH_EDIT_HISTORY_REQUEST });
    const response = await chatService.fetchEditHistory(conversationId, messageId);
    if (response.success) {
      dispatch({ type: CHAT_TYPES.FETCH_EDIT_HISTORY_SUCCESS, payload: { messageId, editHistory: response.editHistory } });
      return { success: true, editHistory: response.editHistory };
    } else {
      dispatch({ type: CHAT_TYPES.FETCH_EDIT_HISTORY_FAILURE, payload: response.message });
      return { success: false, message: response.message };
    }
  } catch (error) {
    dispatch({ type: CHAT_TYPES.FETCH_EDIT_HISTORY_FAILURE, payload: error.message });
    return { success: false, message: error.message };
  }
};
